import React from "react";
import { Col, Row } from "react-bootstrap";
import UserService from "../../../services/UserService";
import API from "../../../services/APIService";

const HierarchyPage = () => {
	const token = new UserService().getLoggedInUser().token;
	const url = API.url("hierarchy");
	const api_url = API.getStaticUrl();
	return (
		<div className="crud-page hierarchy-page">
			<div className="container-fluid">
				<section className="actions">
					<Row>
						<Col md={6} sm={6} xs={12}>
							<h2 className="page-title">Hierarchy</h2>
						</Col>
					</Row>   
				</section>
				<Row>
					<Col md={12}>
						<div className="card card-top-border card-hierarchy fadeInLoadUp">
							<iframe title="iframe" src={`${api_url}/orgchart_assets/hierarchy.html?token=${token}&url=${url}`} frameBorder="0" width="100%" height="650px" />
						</div> 
					</Col>	
				</Row>  
			</div>
		</div>
	);
};
export default HierarchyPage;


// WEBPACK FOOTER //
// ./src/components/pages/hierarchy/HierarchyPage.js